import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";
import { ModalController } from "ionic-angular";

/**
 * Generated class for the SelectFilterComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "select-filter",
  templateUrl: "select-filter.html",
})
export class SelectFilterComponent implements OnInit, AfterViewInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;
  @Input() supportOther: boolean;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  placeholder: string = "pleaseSelect";
  options: string[] = [];
  required: boolean;
  otherConfig: any;
  showOther: boolean = false;
  disabled: boolean;
  readonly: boolean = false;

  currentValue: string = "";

  constructor(
    public formBuilder: FormBuilder,
    public modalCtrl: ModalController
  ) {
    // console.log('Hello SelectFilterComponent Component');
  }

  ngOnInit(): void {
    // console.log( "Group: ", this.group );
    // console.log( "Select Filter config: ", this.config );
    // console.log( "Select Filter w/ other support?: " + this.supportOther );

    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    if (this.config.rules) {
      this.required = this.config.rules.required;
    }
    if (this.config.options) {
      this.options = this.config.options;
    }
    if (this.config.placeholder) {
      this.placeholder = this.config.placeholder;
    }

    this.group.addControl(this.id, this.formBuilder.control(undefined));
    this.disabled = this.group.controls[this.id].disabled;

    // TODO: Validation logic

    // DATA LOADING
    this.group.controls[this.id].valueChanges.subscribe((data) => {
      if (data !== undefined) {
        this.currentValue = data;
      }

      this.disabled = this.group.controls[this.id].disabled;
    });
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());

    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.group.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  openSelectModal(): void {
    if (this.disabled || this.readonly) {
      return;
    }

    let inputModal = this.modalCtrl.create(
      "SelectFilterPage",
      { config: this.config },
      { cssClass: "selectFilterModal" }
    );
    inputModal.onDidDismiss((data) => {
      this.currentValue = data;
      this.group.controls[this.id].setValue(this.currentValue);
      this.group.controls[this.id].setErrors(this.getErrors());
      this.group.markAsTouched();
      // console.log( "New error state for control: ", this.group.controls[this.id].errors );
    });
    inputModal.present();
  }

  getErrors(): ValidationErrors {
    let errors = {};
    let val = this.currentValue;
    // console.log( "Checking errors for val: ", val );
    // console.log( "Field required?: ", this.required );
    if (this.required && (undefined === val || null === val || "" === val)) {
      errors["required"] = true;
    }
    // console.log( "Determined select-filter errors:", errors );
    return Object.keys(errors).length == 0 ? undefined : errors;
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/select-filter/select-filter.ts